import { createFileRoute } from '@tanstack/react-router'

import { loadPVRangeRedirect } from '@/screens/brokers/PVRangeRedirect.loader'

/**
 * `/brokers/pv-range` — the sidebar's "PV range" row with no symbol in view.
 * See `ByStockRedirect.tsx` for why `component` never renders on a real visit.
 */
export const Route = createFileRoute('/_app/brokers/pv-range')({
  loader: loadPVRangeRedirect,
  component: () => null,
})
